import axios from 'axios';
import {
  GET_CLIPS_FILTER,
  GET_FILTERED_CLIPS,
  CLEAR_FILTERED_CLIPS,
  GET_CLIP,
  GET_CLIP_THREAD,
  CLEAR_CLIP_DATA,
  GET_NEW_CLIPS,
  GET_LAST_CLIPS,
  GET_TOP_CLIPS,
  GET_RECOMMENDED_CLIPS,
} from '../constants';

export const getClipsFilterSuccess = response => ({
  type: GET_CLIPS_FILTER,
  response,
});

export const getClipsFilter = () => dispatch => (
  axios.get('/videos/clips/filter')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getClipsFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getClipsFilterSuccess(data));
    })
);

export const getFilteredClipsSuccess = response => ({
  type: GET_FILTERED_CLIPS,
  response,
});

export const getFilteredClips = (page = 1, genre = '', country = '', year = '', language = '') => dispatch => (
  axios.get(`/videos/clips?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== 0 && response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getFilteredClipsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getFilteredClipsSuccess(data));
    })
);

export const clearFilteredClips = () => ({
  type: CLEAR_FILTERED_CLIPS,
});

export const getClipThreadSuccess = response => ({
  type: GET_CLIP_THREAD,
  response,
});

export const clearClipData = () => ({
  type: CLEAR_CLIP_DATA,
});

export const getClipThread = id => dispatch => (
  axios.get(`/videos/media/thread/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getClipThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getClipThreadSuccess(data));
    })
);

export const getClipSuccess = response => ({
  type: GET_CLIP,
  response,
});

export const getClip = id => dispatch => (
  axios.get(`/videos/media/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getClipSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getClipSuccess(data));
    })
);

export const getNewClipsSuccess = response => ({
  type: GET_NEW_CLIPS,
  response,
});

export const getNewClips = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/clips?order=new&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getNewClipsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getNewClipsSuccess(data));
    })
);


export const getLastClipsSuccess = response => ({
  type: GET_LAST_CLIPS,
  response,
});

export const getLastClips = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/clips?order=last&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getLastClipsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getLastClipsSuccess(data));
    })
);

export const getTopClipsSuccess = response => ({
  type: GET_TOP_CLIPS,
  response,
});

export const getTopClips = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/clips?order=top&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getTopClipsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTopClipsSuccess(data));
    })
);


export const getRecommendedClipsSuccess = response => ({
  type: GET_RECOMMENDED_CLIPS,
  response,
});

export const getRecommendedClips = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/clips?order=recommend&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getRecommendedClipsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getRecommendedClipsSuccess(data));
    })
);
